/**
 * @module lib/ajax
 * Utilities for sending AJAX requests
 * You probably don't want to use this library directly
 * @see {@link module:lib/appserver/request} for appserver API methods
 */

import axios from "axios";
import AxiosRetryInterceptor from "lib/ajax/retry";

// Create axios client specifically for lib/ajax. This enhances seperation between us and the 'global' instance
const client = axios.create({});

// Hold reference to our retryInterceptor, but don't do anything with it
// If we ever need to detach from the client, this will make more sense
// eslint-disable-next-line no-unused-vars
const retryInterceptor = new AxiosRetryInterceptor(client);

/**
 * buildQueryString - Builds a query string, escaping the key and value pairs
 *
 * @param  {Object} queryArgs  Key/Value Pairs of arguments
 * @param {Function} [encoder] function to encode URI components
 * @returns {String}           "foo=2&bar=5&a%20space=%2B447432713336"
 */
export function buildQueryString(queryArgs, encoder = encodeURIComponent) {
  var queryArgPairs = [];
  // loop through the keys and build them into a list of pairs ["foo=2","bar=5"]
  for(var key in queryArgs) {
    if(queryArgs.hasOwnProperty(key)) {
      var argValue = queryArgs[key];
      queryArgPairs.push( encoder(key) + "=" + encoder(argValue) )
    }
  }
  // Now join to add the ampersands
  // "foo=2&bar=5"
  return queryArgPairs.join("&");
}

/**
 * remoteAPIRequest - make a simple request to a remote api (POST/x-www-form-urlencoded)
 *
 * @param  {type} url description
 * @returns {type}     description
 */
export function request(url, data, options) {
  return client({
    method: "post",
    url: url,
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    },
    data,
    ...options
  });
}



// WEBPACK FOOTER //
// ./src/lib/ajax/index.js